const SCORECARD_WEIGHTS = {
  driverSafetyWeight: 'driver-safety-weight',
  onTimeClockInPercentageWeight: 'on-time-clock-in-percentage-weight',
  averageCustomerRatingWeight: 'average-customer-rating-weight',
  percentageOfJobsRatedByCustomersWeight:
    'percentage-of-jobs-rated-by-customers-weight',
  installationAuditPassPercentageWeight:
    'installation-audit-pass-percentage-weight',
  averageFourTireInstallTimeWeight: 'average-four-tire-install-time-weight',
  mileageCapturePercentageWeight: 'mileage-capture-percentage-weight',
}

const SCORECARD_TARGETS = {
  percentageOfJobsRatedByCustomersTarget:
    'percentage-of-jobs-rated-by-customers-target',
  averageFourTireInstallTimeTarget: 'average-four-tire-install-time-target',
  mileageCapturePercentageTarget: 'mileage-capture-percentage-target',
}

const ENTRY = {
  employeeId: 'Employee ID:',
  tenure: 'Tenure:',
  driverSafetyScore: 'Driver Safety Score:',
  numberOfHarshEvents: 'Number of Harsh Events:',
  milesDriven: 'Miles Driven:',
  speedingTimeTotalTime: 'Speeding time / Total time:',
  weight: 'Weight:',
  customerRatingScore: 'Customer Rating Score:',
  numberOfJobsRated: 'Number of Jobs Rated by Customers:',
  averageCustomerRating: 'Average Customer Rating:',
  installationAuditScore: 'Installation Audit Score:',
  percentPassingInstallationAudits: '% Passing Installation Audits:',
  fourTireInstallationScore: '4-Tire Installation Score:',
  mileageCaptureScore: 'Mileage Capture Score:',
  onTimeClockInScore: 'On-Time Clock-In Score:',
  percentOnTimeClockIns: '% On-Time Clock-Ins:',
  overallScore: 'Overall Score:',
  overallRank: 'Overall Rank:',
}

const SECTION = {
  driverSafety: 'Driver Safety',
  customerRating: 'Customer Rating',
  installationAudits: 'Installation Audits',
  fourTireInstallTime: '4-Tire Install Time',
  mileageCapture: 'Mileage Capture',
  onTimeClockIn: 'On-Time Clock-In',
}

export { SCORECARD_WEIGHTS, SCORECARD_TARGETS, ENTRY, SECTION }
